/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export function DonatePosterImage() {
    return (
        <svg
            width="55"
            height="85"
            viewBox="0 0 55 85"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <g id="Donate" clipPath="url(#clip0_38_3365)">
                <path
                    id="Vector"
                    d="M54.6127 0.374878H0.37854V84.6163H54.6127V0.374878Z"
                    fill="white"
                    className="shared-donation-promo-color-stroke"
                    strokeWidth="0.87"
                    strokeMiterlimit="10"
                />
                <path
                    id="Vector_2"
                    d="M7.33275 16.217H5.03522V4.34198H17.0247V6.6176H7.33275V16.217Z"
                    className="shared-donation-promo-color-fill"
                />
                <path
                    id="Vector_3"
                    d="M17.0247 48.1978H5.03522V36.3227H7.33275V45.9221H17.0247V48.1978Z"
                    className="shared-donation-promo-color-fill"
                />
                <path
                    id="Vector_4"
                    d="M49.9648 16.217H47.6672V6.6176H37.9753V4.34198H49.9648V16.217Z"
                    className="shared-donation-promo-color-fill"
                />
                <path
                    id="Vector_5"
                    d="M49.9648 48.1978H37.9753V45.9221H47.6672V36.3227H49.9648V48.1978Z"
                    className="shared-donation-promo-color-fill"
                />
                <path
                    id="Vector_6"
                    d="M35.2377 39.7928C31.9102 40.3508 27.2975 42.0248 27.2447 42.0248C23.9701 43.3414 20.8363 42.2777 19.3046 41.5191C18.4859 41.1093 17.7641 40.7606 17.0511 40.5077C15.1056 39.6969 13.4155 38.6768 12.7993 38.0752C12.2359 37.5172 12.0335 36.7063 12.2359 35.9478C12.3856 35.2416 12.9049 34.7271 13.5652 34.5266C15.1497 34.0732 17.5616 34.7795 19.199 35.3898C19.199 35.4247 19.2166 35.4595 19.2518 35.4944C19.9648 36.5581 21.0475 37.2731 22.324 37.5782C23.3011 37.7787 24.3222 37.6828 25.449 37.2731C26.9366 36.715 28.7236 36.7674 28.7236 36.7674C28.9789 36.7674 29.2342 36.5668 29.2342 36.2617C29.2342 36.0088 28.9789 35.756 28.7236 35.756C28.618 35.756 26.7254 35.7037 25.0352 36.314C24.1109 36.6715 23.2394 36.7238 22.5264 36.5668C21.6549 36.3663 20.9419 35.9565 20.3785 35.2939C21.1444 34.2302 23.2483 33.7245 23.706 33.6199C25.8099 33.2101 29.3926 31.0827 29.7535 30.8821C30.5194 30.2718 31.4437 30.0713 32.368 30.0713C33.8028 30.0713 35.3433 30.6293 36.4173 31.135L35.2377 39.8102V39.7928Z"
                    className="shared-donation-promo-color-fill"
                />
                <path
                    id="Vector_7"
                    d="M43.574 41.7022C43.5211 42.0074 43.2659 42.2079 43.0106 42.1643L36.5493 41.2924C36.3997 41.2924 36.294 41.2401 36.1884 41.0919C36.0828 40.9437 36.0828 40.8391 36.0828 40.6908L37.4472 30.9344C37.5 30.6816 37.7025 30.4724 37.9578 30.4724H38.0106L44.4718 31.3442C44.6215 31.3442 44.7271 31.4401 44.8328 31.5448C44.9384 31.693 44.9384 31.7976 44.9384 31.9458L43.574 41.7022Z"
                    className="shared-donation-promo-color-fill"
                />
                <path
                    id="Vector_8"
                    d="M29.9472 13.8368C27.9137 11.8228 24.6215 11.8228 22.588 13.8368L21.5141 14.9005L20.4402 13.8368C18.4067 11.8228 15.1144 11.8228 13.081 13.8368C11.0475 15.8509 11.0475 19.1117 13.081 21.1258L21.5053 29.4697L29.9296 21.1258C31.963 19.1117 31.963 15.8509 29.9296 13.8368H29.9472Z"
                    className="shared-donation-promo-color-fill"
                />
                <path
                    id="Vector_9"
                    d="M54.6215 52.1561H0.36969V84.6251H54.6215V52.1561Z"
                    className="shared-donation-promo-color-fill"
                />
                <path
                    id="Vector_10"
                    d="M3.09857 74.9908H50.9243"
                    stroke="white"
                    strokeWidth="0.87"
                    strokeMiterlimit="10"
                />
                <path
                    id="Vector_11"
                    d="M10.625 65.7139C10.625 66.6294 10.4489 67.3879 10.0968 67.9982C9.7447 68.6086 9.23414 69.0707 8.56512 69.3758C7.89611 69.681 7.09505 69.8379 6.15315 69.8379H3.83801V61.7468H6.39963C7.25351 61.7468 8.00175 61.895 8.62675 62.2002C9.26055 62.4966 9.7447 62.9413 10.088 63.5342C10.4313 64.1271 10.6074 64.8507 10.6074 65.7139H10.625ZM8.82921 65.7575C8.82921 65.1559 8.74118 64.6676 8.56512 64.284C8.38907 63.9004 8.12498 63.6127 7.78167 63.4296C7.43836 63.2465 7.00703 63.1506 6.50527 63.1506H5.58097V68.4167H6.32041C7.16548 68.4167 7.79048 68.19 8.20421 67.7454C8.61794 67.3007 8.82041 66.6381 8.82041 65.7488L8.82921 65.7575Z"
                    fill="white"
                />
                <path
                    id="Vector_12"
                    d="M19.7359 65.7837C19.7359 66.4115 19.6567 66.9782 19.4982 67.4839C19.3398 67.9983 19.1021 68.4342 18.7852 68.8004C18.4683 69.1666 18.0634 69.4543 17.5792 69.6461C17.0951 69.8467 16.5141 69.9426 15.8451 69.9426C15.1761 69.9426 14.6039 69.8467 14.1109 69.6461C13.6268 69.4456 13.2218 69.1666 12.9049 68.8004C12.588 68.4342 12.3504 67.9896 12.1919 67.4752C12.0334 66.9607 11.9542 66.394 11.9542 65.7663C11.9542 64.9293 12.0951 64.1969 12.368 63.5778C12.6408 62.9588 13.0722 62.4705 13.6532 62.1305C14.2342 61.7905 14.9648 61.6161 15.8539 61.6161C16.743 61.6161 17.4736 61.7905 18.037 62.1305C18.6092 62.4705 19.0317 62.9588 19.3134 63.5778C19.5951 64.2056 19.7271 64.938 19.7271 65.775L19.7359 65.7837ZM13.7764 65.7837C13.7764 66.3504 13.8468 66.8387 13.9877 67.2397C14.1285 67.6495 14.3574 67.9634 14.6655 68.1814C14.9736 68.3993 15.3697 68.5127 15.8539 68.5127C16.338 68.5127 16.743 68.3993 17.0511 68.1814C17.3592 67.9634 17.5792 67.6495 17.7201 67.2397C17.8609 66.83 17.9313 66.3504 17.9313 65.7837C17.9313 64.938 17.7729 64.2666 17.4472 63.7784C17.1215 63.2901 16.6021 63.046 15.8627 63.046C15.3785 63.046 14.9736 63.1593 14.6743 63.3773C14.3662 63.5953 14.1373 63.9091 13.9965 64.3189C13.8556 64.7287 13.7852 65.217 13.7852 65.7837H13.7764Z"
                    fill="white"
                />
                <path
                    id="Vector_13"
                    d="M28.6708 69.8379H26.4701L22.9137 63.7173H22.8609C22.8785 63.9701 22.8873 64.2317 22.8961 64.4845C22.9049 64.7374 22.9225 64.999 22.9313 65.2605C22.9401 65.5134 22.9577 65.7749 22.9665 66.0365V69.8466H21.4172V61.7556H23.6003L27.1479 67.8151H27.1831C27.1831 67.5623 27.1655 67.3182 27.1567 67.0653C27.1479 66.8125 27.1391 66.5684 27.1215 66.3242C27.1127 66.0801 27.1039 65.8273 27.0951 65.5831V61.7556H28.6532V69.8466L28.6708 69.8379Z"
                    fill="white"
                />
                <path
                    id="Vector_14"
                    d="M35.7307 69.8379L35.1409 67.9111H32.1655L31.5757 69.8379H29.7095L32.5969 61.712H34.7183L37.6145 69.8379H35.7483H35.7307ZM34.7271 66.4725L34.1373 64.5892C34.1021 64.4671 34.0493 64.3015 33.9877 64.1009C33.9261 63.9004 33.8645 63.6999 33.8028 63.4993C33.7412 63.2901 33.6884 63.1157 33.6532 62.9675C33.618 63.1157 33.5652 63.3075 33.5035 63.5255C33.4419 63.7522 33.3715 63.9614 33.3187 64.162C33.2659 64.3625 33.2131 64.502 33.1866 64.5892L32.5969 66.4725H34.7271Z"
                    fill="white"
                />
                <path
                    id="Vector_15"
                    d="M41.7781 69.8379H40.044V63.1767H37.8257V61.7468H43.9965V63.1767H41.7781V69.8379Z"
                    fill="white"
                />
                <path
                    id="Vector_16"
                    d="M49.956 69.8379H45.2553V61.7468H49.956V63.1506H46.9807V64.9292H49.7447V66.3329H46.9807V68.4167H49.956V69.8292V69.8379Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_38_3365">
                    <rect width="55" height="85" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
